/**
 * Path B organization confirm UI after Paddle + Clerk account creation.
 *
 * - `clerk` (default): use Clerk's "Setup your organization" task (name + logo).
 * - `custom`: use PrefillCreateOrganization with registration company name.
 *
 * Set `REACT_APP_PATH_B_ORG_CONFIRM=custom` to re-enable the custom confirm screen.
 */
export type PathBOrgConfirmMode = 'clerk' | 'custom';

export function getPathBOrgConfirmMode(): PathBOrgConfirmMode {
  const raw = (process.env.REACT_APP_PATH_B_ORG_CONFIRM || 'clerk').trim().toLowerCase();
  return raw === 'custom' ? 'custom' : 'clerk';
}

/** True when Path B should collect company name on /register-company and show our confirm UI. */
export function isPathBCustomOrgConfirmEnabled(): boolean {
  return getPathBOrgConfirmMode() === 'custom';
}
